import * as React from 'react'

import {type ConsoleAgentT} from '@frontrow/console/src/helpers/auth-helpers'
import AgentContext from '@frontrow/console/src/context/agent'

/** @internal */
export const ROLE_GROUPS = {
  admin: 'AZADFreckleConsoleAdmin',
  support: 'AZADFreckleConsoleSupport',
  engineering: 'AZADFreckleConsoleEngineer'
} as const

/** @internal */
export type Role = keyof typeof ROLE_GROUPS

type Props = {
  children: React.ReactNode
  to: Role | Role[]
}

/** @internal */
export function restricted(agent: ConsoleAgentT, roles: Role | Role[]): boolean {
  const roleArray = Array.isArray(roles) ? roles : [roles]
  return !roleArray.some(role => agent.groups.includes(ROLE_GROUPS[role]))
}

export function isSuperUser(agent: ConsoleAgentT): boolean {
  return !restricted(agent, 'admin')
}

export default function Restricted(props: Props): React.ReactElement | null {
  const {to: roles, children} = props

  return (
    <AgentContext.Consumer>
      {agent => (restricted(agent, roles) ? null : children)}
    </AgentContext.Consumer>
  )
}
